export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7640.b23d5ec7.jpg";